import { centralEnabled, centralAccessToken } from './centralAuth';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import { hubUrl } from "@/config/api";
import { readSession } from "@/helpers/storage";

export const crmHubEvents = [
  "ActionClosed",
  "ActionAdded",
  "ActionClosedWithNew",
  "ActionDeleted",
  "CompanyStopChanged",
  "NoteAdded",
  "NoteUpdated",
  "NoteDeleted",
  "ActionLocked",
  "ActionUnLocked",
  "ActionUnlocked",
  "UserMessage",
  "CompanyContactAdded",
  "CompanyContactUpdated",
  "CompanyContactDeleted",
  "OrderPlaced",
  "WorkspaceChanged",
  "PresenceSnapshot",
  "OrderCountChanged",
] as const;

export type CrmHubEventName = (typeof crmHubEvents)[number];

export function createCrmConnection(): HubConnection {
  return new HubConnectionBuilder()
    .withUrl(centralEnabled ? `${hubUrl}?businessId=${encodeURIComponent(readSession()?.businessId || '')}` : hubUrl, {
      accessTokenFactory: () => centralEnabled ? centralAccessToken() : readSession()?.accessToken ?? "",
      withCredentials: false,
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();
}
